import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from '../Text';
import ImageFluid from '../ImageFluid';
import Styles from './ExperiencePost.styles';
import RawHtml from '../RawHtml';
import TagButtons from '../../compound/TagButtons';
import { getKey } from '../../../helpers';
import FormatedDate from '../FormatedDate';


const Container = styled.div`${Styles.container}`;
const Review = styled.div`${Styles.review}`;
const Content = styled.div`${Styles.content}`;
const MainTitle = styled(Text)`${Styles.maintitle}`;
const ImageContainer = styled.div`${Styles.image}`;
const Back = styled.a`${Styles.back}`;
const ExtraTools = styled.div`${Styles.extratools}`;
const Datetext = styled(Text)`${Styles.datetext}`;
/**
 * Experience Post pure component
 * @param  {string} title Titulo de la tarjeta
 * @param  {string} url url del post
 * @param  {string} content resumen
 * @param  {string} image imagen principal
 * @param  {array} tags tags asignados al articulo
 * @param  {string} locale idioma
 * @param  {string} date publish date
 * @returns {JSX}
 */
const ExperiencePost = (
  {
    backtext,
    locale,
    title,
    content,
    review,
    tags,
    image,
  }
) => {
  const tagsPills = tags.map(tag => ({
    titlebutton: getKey(tag, `title_${locale}`),
    key: getKey(tag, 'key'),
    link: `/${locale}/experience${tag.slug}`
  }));
  return (
    <Container className="container">
      <div className="row">
        <div className="col-12">
          <MainTitle className="cbx-bold">{title}</MainTitle>
          <ImageContainer>
            <ImageFluid fluid={image} />
          </ImageContainer>
        </div>
      </div>
      <div className="row">
        <div className="col-md-10 offset-md-1">
          <Review>
            <RawHtml content={review} className="review cbx-bold" />
          </Review>
          <Content>
            <RawHtml content={content} className="content" />
          </Content>
        </div>
      </div>
      <TagButtons items={tagsPills} locale={locale} />
      <ExtraTools className="row">
        <div className="col-md-10 offset-md-1">
          <Back href={`/${locale}/experience`}>{backtext}</Back>
        </div>
      </ExtraTools>
    </Container>
  );
};
ExperiencePost.propTypes = {
  backtext: PropTypes.string,
  title: PropTypes.string,
  review: PropTypes.string,
  content: PropTypes.string,
  image: PropTypes.object,
  tags: PropTypes.array,
  locale: PropTypes.string,
  date: PropTypes.string
};

export default ExperiencePost;
